import {
  ErrorMessage,
  IsLoading,
  RegisterFormFieldType
} from '../../../../../types';

import { OperationFields } from '../../../operationsTypes';

import { WarningFormData } from './WarningForm.types';

import { WarningFormRecordField } from './components/WarningFormRecordField';

import { Form } from '../../../../../helpers/Form';
import { InputField } from '../../../../../helpers/FormFields/InputField';
import { DateTimeField } from '../../../../../helpers/FormFields/DateTimeField';
import { ItemsListFieldRequiredProps } from '../../../../../helpers/FormFields/ItemsListField';
import { DropzoneFieldRequiredProps } from '../../../../../helpers/FormFields/DropzoneField';
import { WorkersMultiselectField } from '../../../../users/helpers/WorkersMultiselectField';

import { operationsKeys, words } from '../../../../../locales/keys';

interface WarningFormProps {
  form: string;
  isLoading?: IsLoading;
  subjectValidationError?: ErrorMessage;
  bodyValidationError?: ErrorMessage;
  dateValidationError?: ErrorMessage;
  completeDatetimeValidationError?: ErrorMessage;
  registerSubject: RegisterFormFieldType<HTMLInputElement>;
}

function WarningForm({
  form,
  control,
  isLoading,
  subjectValidationError,
  bodyValidationError,
  dateValidationError,
  completeDatetimeValidationError,
  registerSubject
}: WarningFormProps &
  ItemsListFieldRequiredProps<WarningFormData> &
  DropzoneFieldRequiredProps<WarningFormData>) {
  return (
    <Form className="flex-1 overflow-y-auto px-2" id={form}>
      <div className="p-4">
        <div className="space-y-3">
          <div>
            <div className="w-full sm:w-auto sm:flex-1">
              <InputField
                disabled
                error={subjectValidationError}
                i18nLabel={operationsKeys.subject}
                inputWrapperClassName="relative mt-1"
                labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
                name={registerSubject.name}
                onChange={registerSubject.onChange}
                ref={registerSubject.ref}
                type="text"
              />
            </div>
          </div>

          <div>
            <WorkersMultiselectField<WarningFormData>
              control={control}
              disabled={isLoading}
              name={OperationFields.MENTIONED_USER_IDS}
              i18nLabel={words.notification}
              inputWrapperClassName="mt-1"
              labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
              menuPosition="fixed"
            />
          </div>

          <div>
            <div className="w-full sm:w-auto sm:flex-1">
              <WarningFormRecordField
                disabled={isLoading}
                control={control}
                error={bodyValidationError}
              />
            </div>
          </div>

          <div>
            <div className="w-full sm:w-auto sm:flex-1">
              <DateTimeField
                control={control}
                disabled={isLoading}
                error={completeDatetimeValidationError}
                i18nLabel={words.from}
                inputWrapperClassName="relative mt-1"
                labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
                name={OperationFields.COMPLETE_DATETIME}
              />
            </div>
          </div>

          <div>
            <div className="w-full sm:w-auto sm:flex-1">
              <DateTimeField
                control={control}
                disabled={isLoading}
                error={dateValidationError}
                i18nLabel={words.to}
                inputWrapperClassName="relative mt-1"
                labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
                name={OperationFields.DATE}
              />
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
}

export default WarningForm;
